var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLearningAdaptiveClose = function SvgLearningAdaptiveClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 28.75,
    height: 30,
    rx: 14.375,
    fill: "#E8EBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99112 10.3661C10.4793 9.87796 11.2707 9.87796 11.7589 10.3661L14.625 13.2322L17.4911 10.3661C17.9793 9.87796 18.7707 9.87796 19.2589 10.3661C19.747 10.8543 19.747 11.6457 19.2589 12.1339L16.3928 15L19.2589 17.8661C19.747 18.3543 19.747 19.1457 19.2589 19.6339C18.7707 20.122 17.9793 20.122 17.4911 19.6339L14.625 16.7678L11.7589 19.6339C11.2707 20.122 10.4793 20.122 9.99112 19.6339C9.50296 19.1457 9.50296 18.3543 9.99112 17.8661L12.8572 15L9.99112 12.1339C9.50296 11.6457 9.50296 10.8543 9.99112 10.3661Z",
    fill: "#12131A"
  })));
};
export default SvgLearningAdaptiveClose;